// src/components/Outro.js
import React from "react";
import "./Intro.css"; // Reusing the same CSS
import logo from "../assets/logo.png";

const Outro = () => {
  return (
    <div>
      {/* Racó Patraix Section */}
      <section className="intro-section">
        <div className="intro-upper">
          <div className="text-left">
            <h1 className="intro-title-left">racó</h1>
          </div>
          <div className="text-right">
            <h1 className="intro-title-right">patraix</h1>
          </div>
        </div>
        {/* Separation line directly below racó patraix 
        <div className="footer-divider"></div>

        {/* Footer Section directly below the line 
        <div className="footer-section">
          <div className="footer-content">
            <div className="footer-left">
              <span className="footer-text">omHaus</span>
            </div>
            <div className="footer-right">
              <img src={logo} alt="Logo" className="footer-logo" />
            </div>
          </div>
        </div>*/}
      </section>
    </div>
  );
};

export default Outro;
